
import { base_url } from "../constants";
import { Home } from "../pages/Home/main";
import { Recurrencia } from "../pages/Recurrencia/main";
import { Capacitacion } from "../pages/Capacitacion/main";
import { Redireccionar } from "../utilities/Redirect/Redirect404";
import ConcursoTikTok2025 from "../pages/Home/concursoTikTok2025/ConcursoTikTok";

const rutas = [     
    { path: `/${base_url}/`, component: Home, exact: true },
    { path: `/${base_url}/recurrencia`, component: Recurrencia, exact: true },
    { path: `/${base_url}/capacitacion`, component: Capacitacion, exact: true },
    { path: `/${base_url}/concurso-tik-tok`, component: ConcursoTikTok2025, exact: true },
    { path: '*', component: Redireccionar },
]; 

export default rutas;